import { Injectable, Inject } from '@angular/core';  
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';  
import { RedirectRequest } from '@azure/msal-browser';  
  
@Injectable({  
  providedIn: 'root'  
})  

export class AuthHelperService {  
  private _isAuthenticated = false; 

  constructor(  
    @Inject(MSAL_GUARD_CONFIG) private readonly msalGuardConfig: MsalGuardConfiguration,  
    private readonly authService: MsalService) {
      this.checkAndSetActiveAccount();
    }  
  
  setLoginDisplay() {  
    return this.authService.instance.getAllAccounts().length > 0;  
  }  
  
  checkAndSetActiveAccount() {  
    let activeAccount = this.authService.instance.getActiveAccount();  
  
    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {  
      let accounts = this.authService.instance.getAllAccounts();  
      this.authService.instance.setActiveAccount(accounts[0]);  
    }  
  }  
  
  loginRedirect() {  
    if (this.msalGuardConfig.authRequest) {  
      this.authService.loginRedirect({  
        ...this.msalGuardConfig.authRequest,  
      } as RedirectRequest);  
    } else {  
      this.authService.loginRedirect();  
    }  
  } 

  get isAuthenticated(): boolean {  
    return this._isAuthenticated;
  }  
  
  set isAuthenticated(value: boolean) {  
    this._isAuthenticated = value;  
  } 
}  
